import React from 'react';
import ContactInfo from '../components/ContactInfo';
import ContactMap from '../components/ContactMap';
import HomeOpenHours from '../components/HomeOpenHours';
import ScrollIntoView from '../components/ScrollIntoView';

const Contact = () => {
  return (
    <ScrollIntoView>
      <div id="contact-page">

        <ContactInfo />
        
        <ContactMap />
        
        <HomeOpenHours />
      
      </div>
    </ScrollIntoView>
  );
};

export default Contact;